<template>
  <div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">筛选查询</div>
      </div>
      <!-- 搜索筛选 -->
      <div>
        <div class="table_item_box">
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">运单号</div>

              <input
                v-model="screen.ordernumber"
                type="text"
                placeholder="请输入运单号"
                class="table_item_input"
              />
            </div>
            <div class="table_item_box_l_r">
              <div class="fill_in_title">批次号</div>

              <input
                v-model="screen.batchname"
                type="text"
                placeholder="请输入批次号"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">国内单号</div>

              <input
                v-model="screen.domesticnumber"
                type="text"
                placeholder="请输入国内单号"
                class="table_item_input"
              />
            </div>
            <div class="table_item_box_l_r">
              <div class="fill_in_title">收件人</div>

              <input
                v-model="screen.recipientname"
                type="text"
                placeholder="请输入收件人"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">国际段运单号</div>

              <input
                v-model="screen.secondtracknumber"
                type="text"
                placeholder="请输入国际段运单号"
                class="table_item_input"
              />
            </div>
            <div class="table_item_box_l_r">
              <div class="fill_in_title">选择线路</div>
              <el-select
                clearable
                class="table_item_input"
                v-model="screen.routeid"
                placeholder="请选择选择线路"
              >
                <el-option
                  v-for="(item, index) in circuitData"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">选择线路</div>
              <el-select
                class="input_select"
                v-model="screen.routeid"
                placeholder="请选择国内快递公司"
              >
                <el-option
                  v-for="item in circuitData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div> -->
          <div class="table_item_box_s" style="flex-direction: column-reverse">
            <div class="table_item_box_l_r"></div>
            <div class="table_item_box_l_s">
              <el-button type="primary" @click="search" round>搜索</el-button>
              <el-button @click="reset" round>重置</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">未入库包裹列表</div>
      </div>
      <div class="table_box">
        <el-table
          v-loading="tableLoading"
          :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
          :data="orderData.content"
          stripe
          style="width: 100%"
        >
          <el-table-column align="center" prop="datecreated" label="创建日期">
          </el-table-column>
          <el-table-column align="center" prop="ordernumber" label="单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="domesticnumber"
            label="国内单号"
          >
          </el-table-column>
          <el-table-column align="center" prop="route" label="线路">
          </el-table-column>
          <el-table-column align="center" prop="recipientname" label="收件人">
          </el-table-column>
          <el-table-column align="center" prop="itemNames" label="包裹内件">
          </el-table-column>
          <el-table-column align="center" prop="stateValue" label="包裹状态">
            <template slot-scope="scope">未入库 </template>
          </el-table-column>
          <el-table-column align="center" prop="status" label="最新状态">
            <template slot-scope="scope">
              {{ scope.row.status ? scope.row.status : "-" }}
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="pickUpLocationName"
            label="取货点"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.pickUpLocationName
                    ? scope.row.pickUpLocationName
                    : "-"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="250">
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="scope.row.isfromchina == 1"
                @click="editInfo(scope.row.id, scope.row.domesticnumber)"
                >改快递单号</el-button
              >
              <el-button
                type="text"
                class="text_li"
                @click="
                  productInformation(
                    scope.row.id,
                    scope.row.isfromchina,
                    scope.row.routeid
                  )
                "
                >改商品信息</el-button
              >
              <el-button type="text" class="text_lsi" @click="del(scope.row.id)"
                >删除包裹</el-button
              >
            </template>
          </el-table-column>
          <el-table-column align="center" label="详情" width="150">
            <template slot-scope="scope">
              <el-button
                @click="details(scope.row.id, scope.row.status)"
                type="text"
                >包裹详情</el-button
              >
              <el-button @click="logistics(scope.row)" type="text"
                >物流详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="paging_box">
          <el-pagination
            @current-change="pageChange"
            background
            layout="prev, pager, next"
            :total="orderData.totalElements"
          >
          </el-pagination>
        </div>
      </div>
      <el-dialog
        title="修改快递单号"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <div class="numbers_info">
          <div class="">单号：{{ ordernumber }}</div>
        </div>
        <el-form
          :model="waybillNumber"
          :rules="rules"
          ref="waybillNumbers"
          class="demo-ruleForm"
        >
          <el-form-item label="国内快递单号" prop="trackingNumber">
            <input
              @input="inputBtn"
              v-model="waybillNumber.trackingNumber"
              type="text"
              class="input_select"
              placeholder="请输入国内快递单号"
            />
          </el-form-item>

          <el-divider></el-divider>
          <el-form-item label="国内快递公司" prop="domesticcarrier">
            <!-- <input
              disabled
              v-model="waybillNumber.domesticcarrier"
              type="text"
              class="input_select"
              placeholder="请输入正确的快递单号获取快递公司"
            /> -->
            <el-select
              clearable
              class="input_select"
              v-model="waybillNumber.domesticcarrier"
              placeholder="请选择国内快递公司"
            >
              <el-option
                v-for="item in expressData"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-divider></el-divider>
        </el-form>
        <!-- <div class="fill_in_list">
          <div class="fill_in_list_l">
            <div class="fill_in_title">国内快递公司</div>
            <div class="fill_in_title_l">*</div>
          </div>
         
        </div>
        <div class="fill_in_list">
          <div class="fill_in_list_l">
            <div class="fill_in_title">国内快递单号</div>
            <div class="fill_in_title_l">*</div>
          </div>
        
        </div> -->
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
          <el-button
            type="primary"
            :loading="loading"
            class="confirm_btn"
            @click="amendNumber('waybillNumbers')"
            >确认</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
export default {
  data() {
    return {
      tableLoading: "",
      loading: false,
      ordernumber: "",
      waybillNumber: {
        domesticcarrier: "",
        trackingNumber: "",
      },
      rules: {
        domesticcarrier: [
          { required: true, message: "请选择快递公司", trigger: "blur" },
        ],
        trackingNumber: [
          { required: true, message: "请输入快递单号", trigger: "blur" },
        ],
      },
      expressData: [],
      routeid: "",
      orderData: [],
      screen: {
        page: 1,
        size: 10,
        secondtracknumber: "",
        ordernumber: "",
        routeid: "",
        state: "1",
        recipientname: "",
        batchname: "",
        domesticnumber: "",
      },
      circuitData: [],
      dialogVisible: false,
      options: [],
      orderID: "",
    };
  },
  created() {
    this.circuit();
    this.orderList();
    this.express();
  },
  methods: {
    //删除包裹
    del(e) {
      this.$confirm("此操作将删除包裹, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          crudDept
            .deleteNotWarehousedOrder({
              orderId: e,
            })
            .then((res) => {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.orderList();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 物流详情
    logistics(item) {
      localStorage.setItem("order", JSON.stringify(item));
      this.$router.push({
        path:
          "/logistics/logistics?code=" +
          item.domesticcarrier +
          "&num=" +
          item.domesticnumber,
      });
    },
    inputBtn(e) {
      /*
      var data = {
        orderNumber: this.waybillNumber.trackingNumber,
      };
      crudDept.queryExpressCompanyNumber(data).then((res) => {
        if (res.comCode) {
          this.waybillNumber.domesticcarrier = res.comCode;
        } else {
          this.waybillNumber.domesticcarrier = "";
        }
      });
      */
    },
    //点击修改快递单号按钮
    editInfo(e, ordernumber) {
      this.ordernumber = ordernumber;
      this.dialogVisible = true;
      this.orderID = e;
    },
    //点击确认修改快递单号
    amendNumber(formName) {
      var that = this;
      if (this.waybillNumber.trackingNumber.indexOf(" ") != -1) {
        this.$message.error("请输入正确的快递单号");
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          var data = {
            id: Number(that.orderID),

            domesticcarrier: this.waybillNumber.domesticcarrier,
            domesticnumber: this.waybillNumber.trackingNumber,
          };
          crudDept
            .updateOrder(data)
            .then((res) => {
              this.loading = false;
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogVisible = false;
              this.$refs[formName].resetFields();
              this.orderList();
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          this.loading = false;
          return false;
        }
      });
    },
    //快递公司
    express() {
      var data = {};
      crudDept.express(data).then((res) => {
        this.expressData = res;
      });
    },
    //分页
    pageChange(e) {
      this.screen.page = e;
      this.orderList();
    },
    selectRouteid(item) {
      this.$forceUpdate();
    },
    //筛查
    search() {
      this.orderList();
    },
    //重置
    reset() {
      this.screen = {
        page: 1,
        size: 10,
        state: "1",
        secondtracknumber: "",
        ordernumber: "",
        routeid: "",
        recipientname: "",
        batchname: "",
        domesticnumber: "",
      };
      this.orderList();
    },
    //订单列表
    orderList() {
      this.tableLoading = true;
      crudDept
        .orderList(this.screen)
        .then((res) => {
          this.orderData = res;
          this.tableLoading = false;
        })
        .catch((res) => {
          this.tableLoading = false;
        });
    },
    // 线路
    circuit() {
      var data = {
        page: 1,
        size: 100,
      };
      crudDept.circuit(data).then((res) => {
        this.circuitData = res.content;
        res.content.map((item) => {
          item.value = item.id;
          item.label = item.name;
        });
        this.circuitData = res.content;
      });
    },
    details(e, status) {
      this.$router.push({
        path: "/parcel/parcelDetail?id=" + e + "&name=" + status,
      });
    },
    productInformation(e, isfromchina, routeid) {
      this.$router.push({
        path:
          "/parcel/productInformation?id=" +
          e +
          "&isfromchina=" +
          isfromchina +
          "&routeid=" +
          routeid,
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
.confirm_btn {
  margin: 0 auto !important;
  background-color: #5178ff;
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  border-radius: 22px;
}
input::-webkit-input-placeholder {
  color: #999999;
}
input::-moz-input-placeholder {
  color: #999999;
}
input::-ms-input-placeholder {
  color: #999999;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  /* width: 27%; */
  border-bottom: 1px solid #dedede;
  /* padding-bottom: 10px; */
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #ff0e0e;
}
.numbers_info {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-bottom: 22px;
}
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: auto !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  /*height:600px;*/
  max-height: calc(100% - 30px) !important;
  max-width: calc(100% - 30px) !important;
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
.table_box {
  margin-top: 32px;
}
.el-table td,
.el-table th {
  text-align: center !important;
}
.text_li {
  color: #ffa401 !important;
}
.text_lsi {
  color: #ff0e0e !important;
}
.el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.table_item_box_s {
  display: flex;
}
.table_item_box_l_s {
  display: flex;
}
.table_item_input >>> .el-input__inner {
  background: none !important;
  outline: none !important;

  border: none;
  /* color: #fff !important; */
  padding: 0;
}
.content_box_title {
  display: flex;
  align-items: center;
}
.circle_l {
  width: 18px;
  height: 18px;
  background: #5178ff;
  border-radius: 50%;
}
.circle_r {
  width: 18px;
  height: 18px;
  background: rgba(81, 120, 255, 0.27);
  border-radius: 50%;
  margin-left: -7px;
}
.text_xl {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 58px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.table_item_box {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 25px 0 0;
  box-sizing: border-box;
}
.table_item_box_l {
  margin-right: 30px;
  text-align: left;
}
.table_item_box_l_r {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #ffffff;

  border: 1px solid #dedede;
  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select {
  width: 100%;
  height: 40px;
  background: #ffffff;

  border: none;
  opacity: 1;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select >>> .el-input__inner {
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}
.input_select_table {
  padding: 0 !important;
  width: 180px;
  height: 40px;

  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #ff0e0e;
}
</style>


// WEBPACK FOOTER //
// src/views/parcel/upcoming.vue